import * as actionTypes from "../Action/Actiontypes";

const initialstate = {
  user: null,
  loading: false,
  error: null,
  profile: {},
};

const AuthReducer = (state = initialstate, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case actionTypes.LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actionTypes.SIGNUP_INIT:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        loading: false,
      };
    case actionTypes.SIGNUP_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case actionTypes.GET_PROFILE_INIT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        loading: false,
      };

    case actionTypes.GET_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case actionTypes.UPDATE_PROFILE_INIT:
      return {
        ...state,
        error: null,
      };

    case actionTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };

    case actionTypes.UPDATE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AuthReducer;
